import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

export type ContactInfo = {
  phone: string;
  email: string;
  address: string;
  hours: string;
  hoursNote: string;
};

export const DEFAULT_CONTACT: ContactInfo = {
  phone: '0118 972 3986',
  email: 'office@fishvolunteercentre.org.uk',
  address: '82 Lea Road, Sonning Common, RG4 9LJ',
  hours: 'Monday – Friday, 9:30 – 11:30',
  hoursNote: 'Excluding bank holidays',
};

const KEYS = [
  'contact_phone',
  'contact_email',
  'contact_address',
  'contact_hours',
  'contact_hours_note',
] as const;

export function telHref(phone: string) {
  const digits = phone.replace(/[^\d+]/g, '');
  return `tel:${digits}`;
}

export function mailHref(email: string) {
  return `mailto:${email.trim()}`;
}

export function useContactInfo() {
  const [info, setInfo] = useState<ContactInfo>(DEFAULT_CONTACT);

  useEffect(() => {
    (async () => {
      const { data } = await supabase
        .from('site_settings')
        .select('key,value')
        .in('key', KEYS as unknown as string[]);
      if (!data) return;
      const map = Object.fromEntries(data.map((r) => [r.key, r.value])) as Record<string, string>;
      setInfo({
        phone: map.contact_phone || DEFAULT_CONTACT.phone,
        email: map.contact_email || DEFAULT_CONTACT.email,
        address: map.contact_address || DEFAULT_CONTACT.address,
        hours: map.contact_hours || DEFAULT_CONTACT.hours,
        hoursNote: map.contact_hours_note ?? DEFAULT_CONTACT.hoursNote,
      });
    })();
  }, []);

  return info;
}
